import { render, staticRenderFns } from "./tryLeason.vue?vue&type=template&id=f55c8f0e&scoped=true&"
import script from "./tryLeason.vue?vue&type=script&lang=js&"
export * from "./tryLeason.vue?vue&type=script&lang=js&"
import style0 from "./tryLeason.vue?vue&type=style&index=0&id=f55c8f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55c8f0e",
  null
  
)

export default component.exports